import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../assets/icons/close-circle.svg';
import { ReactComponent as ExpandIcon } from '../../assets/icons/tables/expand-icon.svg';
import { ReactComponent as NewTabIcon } from '../../assets/icons/tables/new-tab.svg';

interface PropertiesInterface {
  open: boolean;
  title?: string;
  content: JSX.Element;
  position?: 'right' | 'left';
  closePanel: () => void;
  url?: string;
}

/**
 * Custom Side Panel function component
 * @returns JSX.Element
 */
function SidePaneModel(properties: PropertiesInterface) {
  const { title, open, position, content, closePanel, url } = properties;
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation('sharedComp');

  /**
   * Handle close panel function
   */
  const handleClosePanel = () => {
    navigate(location.pathname, { replace: true });
    closePanel();
  };

  /**
   * Handle expand panel function
   */
  const handleExpand = () => {
    handleClosePanel();
    if (url) {
      navigate(url);
    }
  };

  /**
   * Handle new tab function
   */
  const handleNewTab = () => {
    handleClosePanel();
    if (url) {
      window.open(url, '_blank');
    }
  };

  return open
    ? ReactDOM.createPortal(
        <div className={`custom-side-panel-wrap ${position}`} dir={i18n.dir(i18n.language)}>
          <div className="custom-side-panel-header">
            {title?.length ? (
              <div className="header-title">
                <p>{title}</p>
              </div>
            ) : (
              <div className="header-icons" dir={i18n.dir(i18n.language)}>
                <ExpandIcon onClick={handleExpand} className="icon" title={t('expand')} />
                <NewTabIcon onClick={handleNewTab} className="icon" title={t('openInNewTab')} />
              </div>
            )}
            <CloseIcon className="icon" onClick={handleClosePanel} title={t('close')} />
          </div>
          <div className="custom-side-panel-content">{content}</div>
        </div>,
        document.body,
      )
    : null;
}
export default SidePaneModel;

SidePaneModel.defaultProps = {
  title: '',
  position: 'right',
};
